import React from 'react';
import { Box, List, ListItem, ListItemText } from "@mui/material";

interface Props {
  errors: any;
}

export default function ValidationErrors({ errors }: Props) {  
  return (
    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'primary.main' }}>
      {errors && (
        <List aria-label="secondary mailbox folders" dense={true}>
          {errors.map((err: any, i: any) => (
            <ListItem key={i} >
              <ListItemText primary={err} className='errorText'/>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}